module.exports = __webpack_public_path__ + "static/media/tag.cfe87a8b.svg";